/*
  Dope Chain Wars ‟View Registry"
  --------------------------------
  Minimal, framework-agnostic registry that lets any module
  register a draw function for a symbolic view name.
  The core render loop (e.g. DopeOS) simply calls getView(name)
  and passes (ctx, time, width, height, params).
*/

const views = new Map();

/**
 * Register or replace a view.
 * @param {string} name – unique identifier (e.g. 'boot', 'blob').
 * @param {(ctx:CanvasRenderingContext2D,
 *          t:number,
 *          w:number,
 *          h:number,
 *          params?:object)=>void} fn  Draw function.
 */
export function registerView(name, fn) {
  views.set(name, fn);
}

/**
 * Retrieve a view. Falls back to a no-op renderer if not found.
 */
export function getView(name) {
  return views.get(name) || (() => {});
}

/**
 * List all registered views (useful for debugging / dev tools).
 */
export function listViews() {
  return Array.from(views.keys());
}